import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Outlet } from "react-router";
import Notifications from "../../../../shared/components/Notifications";
import Modals from "../../../../shared/components/Modals";
import { authenticate } from "../../../auth/redux/slice";
import { AppDispatch } from "../../../../shared/redux/types";

const RootLayout = () => {
    const dispatch = useDispatch<AppDispatch>();

    useEffect(() => {
        dispatch(authenticate());
    }, [dispatch]);

    return (
        <div className="flex h-screen w-screen flex-col bg-accent">
            <Notifications />
            <Outlet />
            <Modals />
        </div>
    );
};

export default RootLayout;
